import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { SplashScreen } from '@/components/feedback/SplashScreen'
import { DesbloqueioScreen } from '@/features/auth/components/DesbloqueioScreen'
import { useAuthStore } from '@/stores/authStore'

/**
 * Bloqueia rotas que exigem sessão. Redireciona para /login preservando o destino, ou mostra o
 * desbloqueio por biometria quando a API travou a sessão.
 */
export function ProtectedRoute() {
  const status = useAuthStore((state) => state.status)
  const location = useLocation()

  if (status === 'authenticating') return <SplashScreen />
  // Mantém a URL: depois do desbloqueio por biometria, a mesma página abre.
  if (status === 'locked') return <DesbloqueioScreen />

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  }

  return <Outlet />
}
